import React, { useCallback, FC } from "react";
import { useHistory } from "react-router-dom";

import { SingleInputForm } from "src/components";
import { ROUTES } from "src/constants";

import { Container } from "../Reset.styles";

const ResetByEmailPage: FC = () => {
  const history = useHistory();

  const handleSubmit = useCallback(
    (value: string) => {
      history.push(ROUTES.resetConfirmation);
    },
    [history]
  );

  return (
    <Container>
      <SingleInputForm
        inputName="email"
        inputType="email"
        placeholder="Ведите ваш e-mail"
        buttonText="ПОДТВЕРДИТЬ"
        onSubmit={handleSubmit}
        isRequired
      />
    </Container>
  );
};

export default ResetByEmailPage;
